// src/modules/app-views/toolbox/pages/Init/modals/ToolboxParametersModal/tabs/SkuTab.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useState, useCallback } from 'react';
import { Card, Segmented, Alert, Flex } from 'antd';
import translateX from 'utils/translateX';
import appService from 'services/appService';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const SKU_OPTIONS = [
  { value: 'alpha6', label: 'Alpha 6' },
  { value: 'numeric6', label: 'Numerico 6' },
  { value: 'autoIncrement', label: 'Auto Incremento' },
];

const SKU_DESCRIPTIONS = {
  alpha6: 'sku_alpha6_description',
  numeric6: 'sku_numeric6_description',
  autoIncrement: 'sku_auto_increment_description',
};

const SKU_TITLES = {
  alpha6: 'Alpha 6',
  numeric6: 'Numerico 6',
  autoIncrement: 'Auto Incremento',
};

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const SkuTab = ({ loading, setLoading }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const [autoSku, setAutoSku] = useState(() => {
    const rawSku = appService.getModulePreferences({ category: 'sku' });
    return rawSku?.autoSku || 'alpha6';
  });

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleChange = useCallback(
    async value => {
      setAutoSku(value);
      setLoading(true);

      try {
        await appService.updateModulePreferences({
          category: 'sku',
          data: { autoSku: value },
        });

        appService.message({ flag: 's', text: 'saved_successfully' });
      } catch (error) {
        console.error('[SkuTab] Save error:', error);
        appService.message({ flag: 'e', text: 'error_saving' });
        // Revert on error
        setAutoSku(autoSku);
      } finally {
        setLoading(false);
      }
    },
    [setLoading, autoSku]
  );

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Flex vertical style={{ height: '100%' }}>
      <Card title={translateX('sku_generator')} size="small">
        <Flex vertical gap={16}>
          <Segmented
            block
            options={SKU_OPTIONS}
            value={autoSku}
            onChange={handleChange}
            disabled={loading}
          />

          <Alert
            type="info"
            showIcon
            title={SKU_TITLES[autoSku]}
            description={translateX(SKU_DESCRIPTIONS[autoSku])}
          />
        </Flex>
      </Card>
    </Flex>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default SkuTab;
